module.exports = __webpack_public_path__ + "img/logo.3ac57905.svg";